import styled from "styled-components";
import { colors } from "../../../../styles/variables";

export const StyledBundle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const StyledBundleLineItem = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledQuantity = styled.div`
  margin-right: 4px;
`;

export const StyledCustomizations = styled.div`
  margin-top: 6px;
  width: 100%;
`;

export const StyledBundleWithCustomizations = styled.div`
  width: 100%;
`;

export const StyledBundleItemContainer = styled.div`
  margin-bottom: 6px;
`;

export const StyledHeadingContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-bottom: 5px;
`;

export const StyledBundleTitle = styled.span`
  font-weight: 700;
`;

export const StyledInterval = styled.div`
  font-style: italic;
`;

export const StyledSubscribe = styled.div`
  color: ${colors.gray600};
  display: flex;
  justify-content: flex-start;
  line-height: normal;
  margin-top: 5px;
`;

export const StyledSubscribeDetails = styled.div`
  color: ${colors.gray600};
  font-size: 13px;
  padding-top: 2px;
`;

export const StyledSubscribeLogo = styled.div`
  margin-right: 4px;
`;
